<div class="dxf-modal">

  <div class="dxf-header">
    <div class="dxf-header-title">
      <img src="assets/icon/Polygon.svg" alt="" />
      <span>{{ 'GLOBAL.DXF' | translate }}</span>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="cancel()"
            [title]="'GLOBAL.FERMER' | translate">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="dxf-body">

    <input type="file" id="dxfFileInput" accept=".dxf" hidden (change)="onFileSelected($event)" />

    <button type="button" class="dxf-dropzone" [class.filled]="fileName()"
            (click)="triggerFilePicker()">
      <i class="fas fa-upload"></i>
      <span class="dxf-dropzone-label">
        {{ fileName() || ('GLOBAL.SELECT' | translate) }}
      </span>
      <small *ngIf="!fileName()">.dxf</small>
    </button>

    <div class="dxf-color">
      <label for="dxfColorInput">{{ 'GLOBAL.COLOR' | translate }}</label>
      <input id="dxfColorInput" type="color" [(ngModel)]="color" />
    </div>

  </div>

  <div class="dxf-footer">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      {{ 'GLOBAL.FERMER' | translate }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!canSave" (click)="save()">
      {{ 'GLOBAL.VALIDER' | translate }}
    </button>
  </div>

</div>
